(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  function isMobile() {
    return window.isMobile || window.innerWidth <= 768;
  }

  function isTablet() {
    return window.isTablet || window.innerWidth <= 1024;
  }

  function animate(root) {
    if (root.dataset.escapeAnimationInitialized === 'true') {
      return;
    }

    root.dataset.escapeAnimationInitialized = 'true';

    if (!window.gsap || !window.ScrollTrigger || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    var animationMedia = gsap.matchMedia();

    animationMedia.add('(min-width: 1025px)', function () {
    var artistSection = root.querySelector('.section--puzzle-art');
    var artistTitle = root.querySelector('.puzzle-art__title');
    var artistIntroText = root.querySelector('.puzzle-art > .text.text--product');
    var artistImage = root.querySelector('.puzzle-art__img');
    var artistQuote = root.querySelector('.puzzle-art__citation');

    if (artistSection && artistTitle && artistIntroText && artistImage) {
      var getArtistMotion = function () {
        var titleMargin = parseFloat(window.getComputedStyle(artistTitle).marginBottom) || 0;
        var textMargin = parseFloat(window.getComputedStyle(artistIntroText).marginBottom) || 0;

        return {
          titleStartOffset: 150,
          titleEndOffset: -100,
          textLag: Math.max(80 - titleMargin, 0),
          imageLag: textMargin * 3
        };
      };
      var artistMotion = getArtistMotion();
      var setArtistProgress = function (progress) {
        var titleY = artistMotion.titleStartOffset
          + (artistMotion.titleEndOffset - artistMotion.titleStartOffset) * progress;
        var textCatchProgress = Math.min(progress / 0.45, 1);
        var imageCatchProgress = Math.min(progress / 0.75, 1);
        var textY = titleY + artistMotion.textLag * (1 - textCatchProgress);
        var imageY = textY + artistMotion.imageLag * (1 - imageCatchProgress);

        gsap.set(artistTitle, { y: titleY });
        gsap.set(artistIntroText, { y: textY });
        gsap.set(artistImage, { y: imageY });
      };
      var artistTrigger = ScrollTrigger.create({
        trigger: artistSection,
        start: 'top bottom',
        end: 'bottom top',
        onUpdate: function (self) {
          setArtistProgress(self.progress);
        },
        onRefresh: function (self) {
          artistMotion = getArtistMotion();
          setArtistProgress(self.progress);
        }
      });

      setArtistProgress(artistTrigger.progress);
    }

    if (artistSection && artistQuote) {
      gsap.fromTo(artistQuote, {
        y: 70
      }, {
        y: -30,
        ease: 'none',
        scrollTrigger: {
          trigger: artistSection,
          start: 'top bottom',
          end: '+=1000',
          scrub: true
        }
      });
    }

    root.querySelectorAll('.video-product').forEach(function (video) {
      var section = video.closest('.section--video-product');

      gsap.fromTo(video, {
        scale: 1.1
      }, {
        scale: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: '+=1000',
          scrub: true
        }
      });
    });

    root.querySelectorAll('.escape-info').forEach(function (item) {
      var content = item.querySelector('.escape-info__content');
      var image = item.querySelector('.escape-info__img');
      var contentDistanceMultiplier = 1.75;

      gsap.fromTo(content, {
        y: (isTablet() ? 50 : 140) * contentDistanceMultiplier
      }, {
        y: (isTablet() ? -40 : -120) * contentDistanceMultiplier,
        ease: 'none',
        scrollTrigger: {
          trigger: item,
          start: 'top bottom',
          end: '+=2200',
          scrub: true
        }
      });

      gsap.fromTo(image, {
        y: isTablet() ? 20 : 60
      }, {
        y: isTablet() ? -20 : -50,
        ease: 'none',
        scrollTrigger: {
          trigger: item,
          start: 'top bottom',
          end: '+=2200',
          scrub: true,
        }
      });
    });

    var artworkSection = root.querySelector('.section--puzzle-escape');

    if (artworkSection) {
      var layers = [
        { selector: '.puzzle-escape__bg', from: 0, to: 100 },
        { selector: '.puzzle-escape__illustration', from: 0, to: -460 },
        { selector: '.puzzle-escape__fish', from: 400, to: -570 }
      ];

      layers.forEach(function (layer) {
        var element = artworkSection.querySelector(layer.selector);
        var divisor = isMobile() ? 2 : 1;

        gsap.fromTo(element, {
          y: layer.from / divisor
        }, {
          y: layer.to / divisor,
          ease: 'none',
          scrollTrigger: {
            trigger: '.puzzle-escape__imgs',
            start: 'top bottom',
            end: '+=1800',
            scrub: true
          }
        });
      });

      var artworkTitle = artworkSection.querySelector('.puzzle-escape__title');
      var artworkText = artworkSection.querySelector('.puzzle-escape > .text');
      var artworkTextParallax = gsap.timeline({
        scrollTrigger: {
          trigger: artworkSection,
          start: 'top bottom',
          end: '+=1500',
          scrub: true,
        }
      });

      artworkTextParallax.fromTo(artworkTitle, {
        y: isMobile() ? 20 : 40
      }, {
        y: isMobile() ? -100 : -160,
        ease: 'none'
      }, 0);

      artworkTextParallax.fromTo(artworkText, {
        y: isMobile() ? 20 : 40
      }, {
        y: isMobile() ? -100 : -160,
        ease: 'none'
      }, 0);
    }
    var positions = [
      { from: 200, to: -200 },
      { from: 600, to: -350 },
      { from: 300, to: -300 },
      { from: 400, to: -350 },
      { from: 700, to: -450 },
      { from: 800, to: -800 },
      { from: 200, to: -200 },
      { from: 300, to: -300 },
      { from: 400, to: -350 },
      { from: 700, to: -450 },
      { from: 200, to: -200 },
      { from: 300, to: -300 },
    ];

    function initPuzzleEscapeScroll(section) {
      if (!section) {
        return;
      }

      positions.forEach(function (position, index) {
        var icon = section.querySelector(".puzzle-escape__icon--" + (index + 1));

        if (!icon) {
          return;
        }

        gsap.fromTo(icon, {
          y: position.from / 16 + "rem",
        }, {
          y: position.to / 16 + "rem",
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "+=1500",
            scrub: true,
          },
        });
      });
    }
    
    initPuzzleEscapeScroll(artworkSection);

    if (!isTablet()) {
      root.querySelectorAll('.craft-item').forEach(function (item) {
        var content = item.querySelector('.craft-item__content');
        var image = item.querySelector('.craft-item__img');

        gsap.fromTo(content, {
          y: '200%'
        }, {
          y: '-100%',
          ease: 'none',
          scrollTrigger: {
            trigger: item,
            start: 'top bottom',
            end: '+=2000',
            scrub: true
          }
        });

        gsap.fromTo(image, {
          y: '30%'
        }, {
          y: '-15%',
          ease: 'none',
          scrollTrigger: {
            trigger: item,
            start: 'top bottom',
            end: '+=2000',
            scrub: true
          }
        });
      });
    }

    ScrollTrigger.refresh(true);
    });
  }

  function init() {
    document.querySelectorAll('.section--escape-puzzle').forEach(animate);
  }

  ready(init);

  window.addEventListener('load', function () {
    if (window.ScrollTrigger) {
      window.ScrollTrigger.refresh(true);
    }
  }, { once: true });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.matches('.section--escape-puzzle')
      ? event.target
      : event.target.querySelector('.section--escape-puzzle');

    if (root) {
      animate(root);
    }
  });
})();
